<template>
  <section class="message">
    <span>{{ $t("helpers.chat.message") }}</span>

    <section class="description">
      <v-textarea
        v-model="description"
        :label="$t('inputs.description')"
        :placeholder="'Descreva a mensagem...'"
        class="border__radius-10"
        rows="3"
        outlined
        hide-details
      ></v-textarea>
    </section>

    <section class="footer">
      <Back @changeComponent="setComponent" />
      <Send @save="sendEmail" />
    </section>
  </section>
</template>

<script>
import Back from "./Back.vue";
import Send from "./Send.vue";
import { makeRequest } from "@/services";
import { getConnectedUser } from "@/utils/localStorage";
import { mapActions } from "vuex";

export default {
  name: "HelpMessageComponent",

  data: () => ({
    description: null,
  }),

  components: {
    Back,
    Send,
  },

  methods: {
    ...mapActions(["changeHelpModalStatus"]),

    setComponent(component) {
      this.$emit("changeComponent", component);
    },

    async sendEmail() {
      if (this.description !== null && this.description !== "") {
        const userData = getConnectedUser();
        const systemName = `${this.$t("system_abbreviation")} - ${this.$t(
          "system_name"
        )}`;

        const data = {
          subject: this.$t("helpers.chat.user_support"),
          system: systemName,
          description: this.description,
          name: userData.name,
          email: userData.email,
          cpf: userData.cpf,
        };

        const { status } = await makeRequest("POST", "report", data);

        if (status) {
          this.closeModal();
        }

        this.$snackbar.setParams(
          status ? "success" : "error",
          status ? this.$t("messages.success") : this.$t("messages.error"),
          status
            ? this.$t("messages.success_send")
            : this.$t("messages.error_send")
        );
      } else {
        this.$snackbar.setParams(
          "warning",
          this.$t("messages.error_not_defined"),
          this.$t("messages.check_fields")
        );
      }
    },

    closeModal() {
      this.description = null;
      this.$emit("changeComponent", "Options");
      this.changeHelpModalStatus(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 14px;

  .description {
    width: 100%;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
  }
}
</style>
